const table105 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "profit_loss_current_period",
        name: "当期利益又は当期の欠損の額",
        editable: true
    },
    {
        key: "provision_income_taxes_loss_corporate",
        name: "損金経理をした納税充当金_法人税・住民税及び事業税",
        editable: true
    },
    {
        key: "provision_income_taxes_loss_public_due",
        name: "損金経理をした納税充当金_租税公課等",
        editable: true
    },
    {
        key: "provision_income_taxes_reversal",
        name: "納税充当金の戻入による益金算入額",
        editable: true
    },
    {
        key: "non_incidental_tax_loss",
        name: "損金経理をした通算税効果額_附帯税以外分",
        editable: true
    },
    {
        key: "incidental_tax_loss",
        name: "損金経理をした通算税効果額_附帯税(利子税を除く)分",
        editable: true
    },
    {
        key: "non_incidental_tax_loss_corporate",
        name: "損金経理をした連結法人税個別帰属額等_附帯税以外分",
        editable: true
    },
    {
        key: "non_incidental_tax_loss_holding_corporate",
        name: "損金経理をした連結法人税個別帰属額等_附帯税以外分_通算親法人のみ入力",
        editable: true
    },
    {
        key: "incidental_tax_loss_corporate",
        name: "損金経理をした連結法人税個別帰属額等_附帯税(利子税を除く)分",
        editable: true
    },
    {
        key: "non_incidental_tax_revenue",
        name: "収益として経理した通算税効果額_附帯税以外分",
        editable: true
    },
    {
        key: "incidental_tax_revenue",
        name: "収益として経理した通算税効果額_附帯税(利子税を除く)分",
        editable: true
    },
    {
        key: "non_incidental_tax_revenue_corporate",
        name: "収益として経理した連結法人税個別帰属額等_附帯税以外分",
        editable: true
    },
    {
        key: "non_incidental_tax_revenue_holding_corporate",
        name: "収益として経理した連結法人税個別帰属額等_附帯税以外分_通算親法人のみ入力",
        editable: true
    },
    {
        key: "incidental_tax_revenue_corporate",
        name: "収益として経理した連結法人税個別帰属額等_附帯税(利子税を除く)分",
        editable: true
    },
    {
        key: "application_tax_effect",
        name: "税効果会計の適用",
        editable: true
    },
    {
        key: "income_taxes_differed_adjustment",
        name: "法人税等調整額_加減区分",
        editable: true
    },
    {
        key: "income_taxes_differed_amount",
        name: "法人税等調整額_金額",
        editable: true
    }
];

export { table105 };
